module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.diff))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b45d31c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/multiple/components/variables/amount-total-diff-x1-x3-total.vue
// module id = 1047
// module chunks = 0